export type ImgSourceMap = {
    [propName in string]: IImgSource;
};

export type SystemType = 'cn' | 'en' | 'em' | 'jp' | 'tw';

export type UserLogoMapType = {
    [key in SystemType]: string;
};

export type UserLogoMapMobileType = {
    [key in SystemType]: string[];
};

export interface IImgSource {
    id?: string;
    src: string;
    srcEn?: string;
    srcCom?: string;
}

export enum Platform {
    TWWW = 'twww',
    MOBILE = 'mobile',
}

export const isShowComImage = () => {
    const systemType = SYSTEM.toLowerCase();
    // en和em站点图片展示区分与cn\jp\tw
    return systemType === 'en' || systemType === 'em';
};

export const getCurrentLocal = () => {
    return LOCALE.toLowerCase();
};

export const initImage = (data: ImgSourceMap) => {
    const isCom = isShowComImage();
    const currentLocal = getCurrentLocal();
    for (let key in data) {
        const { id, src, srcCom, srcEn } = data[key];
        const imgElement = document.getElementById(id || '') as HTMLImageElement;
        if (!imgElement) {
            continue;
        }
        if (isCom) {
            imgElement.src = srcCom || src;
        } else {
            imgElement.src = currentLocal === 'cn' ? src : srcEn || src;
        }
    }
};

export const showCustomImage = (data: UserLogoMapType, dom: string) => {
    const systemType = SYSTEM.toLowerCase() as SystemType;
    const src = data[systemType];
    const imgElement = document.getElementById(dom) as HTMLImageElement;
    imgElement && (imgElement.src = src);
};

export const showCustomImageMobile = (data: UserLogoMapMobileType, dom: string, className?: string) => {
    if (!dom) {
        return;
    }
    const systemType = SYSTEM.toLowerCase() as SystemType;
    const srcList = data[systemType];
    const containerElement = document.getElementById(dom) as HTMLImageElement;
    srcList.forEach((item) => {
        const img = document.createElement('img');
        className && img.classList.add(className);
        img.setAttribute('alt', '');
        img.setAttribute('src', item);
        containerElement.appendChild(img);
    });
};

export async function checkIsARMArch() {
    if (navigator.userAgentData && !!navigator.userAgentData.getHighEntropyValues) {
        const result = await navigator.userAgentData.getHighEntropyValues(['architecture']);
        const { architecture } = result;

        if (architecture === 'arm64') {
            return true;
        }
    }

    const webGLContext = document.createElement('canvas').getContext('webgl');
    if (!webGLContext) {
        return false;
    }
    const webGLDebugInfo = webGLContext.getExtension('WEBGL_debug_renderer_info');
    const g = (webGLDebugInfo && webGLContext.getParameter(webGLDebugInfo.UNMASKED_RENDERER_WEBGL)) || '';
    if (g.match(/Apple/) && !g.match(/Apple GPU/)) {
        return true;
    }

    return false;
}

export async function getDesktopClientDownloadLink() {
    const downloadLink = 'https://' + location.host + '/napi/desktop/download';
    const isARMArch = await checkIsARMArch();
    return `${downloadLink}${isARMArch ? '?isArm=1' : ''}`;
}

export function getCdnDomain(system: SystemType) {
    return {
        cn: 'statics-cdn-cn.umucdn.cn',
        en: 'd1bvk99i2a79wx.cloudfront.net',
        em: 'dmks9efzatfsk.cloudfront.net',
        jp: 'dpfrzbu0cqnmm.cloudfront.net',
        tw: 'd1yemi1ss2f2oh.cloudfront.net',
    }[system];
}
